import { createContext } from 'react';

interface IFeatureContext {
  featureList: string[];
}

export const FeatureContext = createContext<IFeatureContext>({ featureList: [] });
